const en = {
  // Navbar
  nav_features: "Features",
  nav_howItWorks: "How It Works",
  nav_download: "Download",
  nav_signIn: "Sign In",
  nav_downloadApp: "Download App",
  nav_partners: "For partners",

  // Hero
  hero_badge: "Global Payments · Live",
  hero_titleAccent: "Your ultimate",
  hero_title2: "digital wallet",
  hero_subtitle: "Send, receive, and exchange money instantly across 150+ countries. Zero borders, lightning speed, total control.",
  hero_downloadFree: "Download Free",
  hero_seeHow: "See how it works",
  hero_activeUsers: "Active Users",
  hero_services: "services",
  hero_appRating: "App Store",
  hero_recentActivity: "Recent Activity",
  hero_topUp: "Top Up",
  hero_send: "Send",
  hero_exchange: "Exchange",
  hero_history: "History",
  hero_verifiedSecure: "Verified & Secure",
  hero_today: "today",
  hero_usdBalance: "USD Balance",
  hero_eurBalance: "EUR Balance",
  hero_btc: "BTC",
  hero_kztBalance: "KZT Balance",
  hero_tx1: "Service Top-Up",
  hero_tx2: "Received from John",
  hero_tx3: "EUR → USD",
  hero_tx4: "Received from Max",
  hero_minAgo: "2 min ago",
  hero_hrAgo: "1 hr ago",
  hero_hrsAgo: "3 hr ago",

  // Features
  feat_badge: "Why BroMoney",
  feat_title1: "Everything you need,",
  feat_titleAccent: "nothing you don't",
  feat_subtitle: "Fast, secure, simple.",
  feat_instant_title: "Fast Transfers",
  feat_instant_desc: "From 5 minutes to 48 hours — depending on the transfer method.",
  feat_services_title: "Service Payments",
  feat_services_desc: "Pay hundreds of services in one tap — utilities, subscriptions, internet and more.",
  feat_multicurrency_title: "Multi-Currency & Crypto",
  feat_multicurrency_desc: "Cryptocurrencies across multiple chains, USDT, and popular fiat — all in one wallet.",
  feat_security_title: "Security",
  feat_security_desc: "Reliable encryption for your transactions and data. Your funds are protected 24/7.",
  feat_app_title: "Mobile App",
  feat_app_desc: "Native apps for iOS and Android with full wallet functionality.",
  feat_popular: "Popular",

  // Usage Flow
  flow_badge: "How It Works",
  flow_title1: "Up and running in",
  flow_titleAccent: "3 simple steps",
  flow_subtitle: "No delays. Just a better way to manage your money.",
  flow_step1_title: "Create your account",
  flow_step1_desc: "Sign up in 2 minutes. Quick, paperless verification — wallet ready to go.",
  flow_step2_title: "Store money safely",
  flow_step2_desc: "BroMoney is your secure digital vault. Top up by withdrawing from another service and keep full control of your funds at any time.",
  flow_step3_title: "Send & pay",
  flow_step3_desc: "Transfer, convert currencies and pay for services — fast, in a few taps.",
  flow_avgSetup: "Average setup:",
  flow_2min: "2 minutes",
  flow_support: "Support from",
  flow_supportTime: "11:00 to 02:00 (GMT+5)",
  flow_fundProtected: "Funds protected up to",

  // Personal/Business
  pb_badge: "Partners",
  pb_title1: "Business & Partnership",
  pb_titleAccent: "Powerful for business.",
  pb_subtitle: "Whether you're sending money abroad or running a global store, BroMoney scales with you.",
  pb_personal_title: "Personal",
  pb_personal_sub: "For everyday individuals",
  pb_personal_tag: "For you",
  perk_send: "Send money to friends and family in seconds",
  perk_exchange: "Exchange currencies at live interbank rates",
  perk_app: "Beautiful mobile app for iOS and Android",
  perk_history: "Full transaction history and spending insights",
  perk_card: "Virtual & physical debit card included",
  perk_security: "Funds protected by world-class security",
  pb_downloadApp: "Download the App",
  pb_business_title: "Business",
  pb_business_sub: "For merchants & companies",
  bperk1: "Accept payments from 150+ countries instantly",
  bperk2: "Powerful API & ready-made checkout integrations",
  bperk3: "Real-time business analytics dashboard",
  bperk4: "Multi-user roles and team permissions",
  bperk5: "Recurring billing and subscription tools",
  bperk6: "Dedicated account manager & priority support",
  pb_contactBusiness: "Contact us for Business",
  pb_reviews_title: "What our users say",
  pb_reviews_rating: "4.9 out of 5 · 2,400+ reviews",
  review1_text: "Great wallet — fast withdrawals in both crypto and fiat. Exchange rates are excellent, haven't seen such conditions elsewhere. Recommend to anyone working with international transfers.",
  review2_text: "Clean and intuitive interface, easy to understand right away. Support responds quickly and to the point. I use it every day — very convenient.",
  review3_text: "Paying for services is awesome. It's convenient to store money, transfer to the right accounts when needed. Safe and a real lifesaver.",

  // CTA
  cta_badge: "Start Today — It's Free",
  cta_title1: "Your money,",
  cta_title2: "everywhere you go",
  cta_subtitle: "Join thousands of users who trust BroMoney for fast, secure, and borderless payments every day.",
  cta_downloadOn: "Download on the",
  cta_appStore: "App Store",
  cta_downloadApk: "Download for",
  cta_android: "Android",
  cta_getItOn: "Get it on",
  cta_googlePlay: "Google Play",
  cta_rating: "4.9 rating on App Store",
  cta_bankSecurity: "Bank-grade security",
  cta_noHidden: "No hidden charges",
  cta_account: "Personal account",

  // Footer
  footer_desc: "Your ultimate digital wallet for instant global payments, transfers, and exchange.",
  footer_goToWallet: "Go to Wallet",
  footer_downloadAppStore: "Download on App Store",
  footer_downloadApk: "Download APK",
  footer_downloadGooglePlay: "Download APK (Google Play)",
  footer_copyright: "BroMoney. All rights reserved.",
  footer_regulated: "BroMoney is regulated under EU PSD2 directive. Licensed by FCA.",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",

  // Language names
  lang_ru: "Русский",
  lang_kk: "Қазақша",
  lang_uz: "O'zbekcha",
  lang_en: "English",
};

export default en;
